import { NavLink } from "react-router-dom";

export const NAV_ITEMS = [
  { to: "/", label: "Overview", shortLabel: "Home", end: true, testid: "dock-overview", navTestid: "nav-overview" },
  { to: "/accounts", label: "Accounts", shortLabel: "Accounts", testid: "dock-accounts", navTestid: "nav-accounts" },
  { to: "/reports", label: "Reports", shortLabel: "Reports", testid: "dock-reports", navTestid: "nav-reports" },
  { to: "/commands", label: "Command Center", shortLabel: "Commands", testid: "dock-commands", navTestid: "nav-commands" },
  { to: "/notifications", label: "Notifications", shortLabel: "Alerts", testid: "dock-notifications", navTestid: "nav-notifications" },
  { to: "/audit", label: "Audit Logs", shortLabel: "Audit", testid: "dock-audit", navTestid: "nav-audit", roles: ["admin", "manager"] },
  { to: "/admin", label: "Admin", shortLabel: "Admin", testid: "dock-admin", navTestid: "nav-admin", roles: ["admin"] },
];

export default function BottomDock({ user, icons }) {
  const navItems = NAV_ITEMS.filter((n) => !n.roles || n.roles.includes(user?.role));

  return (
    <nav className="bottom-dock lg:hidden" aria-label="App navigation" data-testid="bottom-dock">
      <div className="bottom-dock-inner">
        {navItems.map((n) => {
          const Icon = icons[n.to] || icons.default;
          return (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={n.testid}
              className={({ isActive }) =>
                `bottom-dock-item${isActive ? " bottom-dock-item-active" : ""}`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="bottom-dock-icon-wrap" aria-hidden="true">
                    <Icon size={22} weight={isActive ? "fill" : "duotone"} />
                  </span>
                  <span className="bottom-dock-label">{n.shortLabel}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
